import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '@/components/Navbar';
import PDFViewer from '@/components/PDFViewer';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Viewer = () => {
  const { editionId } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [edition, setEdition] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEdition();
  }, [editionId]);

  const fetchEdition = async () => {
    try {
      const response = await axios.get(`${API}/editions/${editionId}`);
      setEdition(response.data);
    } catch (error) {
      console.error('Error fetching edition:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <div className="flex justify-center items-center h-[calc(100vh-64px)]">
          <div className="text-2xl text-[#1E293B]">{t('loading')}</div>
        </div>
      </div>
    );
  }

  if (!edition) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <div className="flex flex-col justify-center items-center h-[calc(100vh-64px)] space-y-4">
          <div className="text-2xl text-[#1E293B]">{t('noEditions')}</div>
          <Button onClick={() => navigate('/')} data-testid="back-home">
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t('home')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="h-[calc(100vh-64px)]" data-testid="pdf-viewer-container">
        <PDFViewer pdfUrl={edition.pdfUrl} />
      </div>
    </div>
  );
};

export default Viewer;
